<template>
  <div>
    <loading-block v-if="!loaded"></loading-block>
    <v-card v-else>
      <v-card-title>
        <v-row>
          <v-col cols="8">
            <v-text-field
              prepend-icon="search"
              v-model="search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="2" class="text-right">
            <v-btn color="primary" @click="downloadPop('pdf')">Download PDF</v-btn>
          </v-col>
          <v-col cols="2" class="text-center">
            <v-btn color="primary" @click="downloadPop('image')">Download Image</v-btn>
          </v-col>
        </v-row>
      </v-card-title>

      <v-data-table
        class="px-5 py-3tabulardata"
        :headers="headers"
        :items="listItem"
        :page.sync="page"
        :items-per-page="itemsPerPage"
        :search="search"
        @page-count="pageCount = $event"
        :custom-filter="customFilter"
        :footer-props="{
          'items-per-page-options': [10, 20, 40, -1]
        }"
      >
        <template v-slot:[`item.name`]="{ item }">
          <div class="inline-logo-name limited-img-height">
            <img
              v-if="item.image"
              style="width:60px; height:auto; max-height:60px; vertical-align:middle;"
              :src="item.image"
              :alt="item.name"
            />
            <span style="margin-left:20px;">{{ item.name }}</span>
          </div>
        </template>
        <template v-slot:[`item.category`]="{ item }">
          <div class>{{ getLocationProductCategoryNameFromId(item.category_id) }}</div>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <div>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <a v-on:click.prevent="viewDetails(item)">
                <v-btn v-on="on" fab small dark color="primary" class="mr-2" depressed>
                  <v-icon dark>edit</v-icon>
                </v-btn>
              </a>
            </template>
            <span>Edit</span>
          </v-tooltip>
          <!-- assign category -->
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <a v-on:click.prevent="assignCategory(item)">
                <v-btn v-on="on" fab small dark color="primary" class="mr-2" depressed>
                  <v-icon dark>mdi-format-list-checks</v-icon>
                </v-btn>
              </a>
            </template>
            <span>Assign Location Category</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <a v-on:click.prevent="productCard(item)">
                <v-btn v-on="on" fab small dark color="primary" class="mr-2" depressed>
                  <v-icon dark>mdi-qrcode</v-icon>
                </v-btn>
              </a>
            </template>
            <span>Product Card</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <a v-on:click.prevent="deleteItem(item)">
                <v-btn v-on="on" fab small dark color="primary" class="mr-2" depressed>
                  <v-icon dark>delete</v-icon>
                </v-btn>
              </a>
            </template>
            <span>Delete</span>
          </v-tooltip>
          </div>
        </template>
        <template v-slot:no-data>
          <p class="mb-0">No data.</p>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { BrandAPI } from '@/clients/product/brand.api'
import { LocationProductAPI } from '@/clients/location/location.product.api'
import { LocationCategoryAPI } from '@/clients/location/location.category.api'
import { mapActions, mapGetters } from 'vuex'
import _ from 'lodash'
import { defaultFilter } from 'vuetify/lib/util/helpers'

import LoadingBlock from '@/components/custom-components/LoadingBlock.vue'
export default {
  components: {
    LoadingBlock
  },
  data() {
    return {
      loaded: false,
      listItem: [],
      headers: [
        { text: 'Name', value: 'name', sortable: true, width: 300 },
        { text: 'Description', value: 'description', sortable: true, search: false },
        { text: 'Category', value: 'category', sortable: true, search: false },
        { text: 'Actions', value: 'action', sortable: false, width: 250 }
      ],
      locationCategoryList: [],
      brandList: []
    }
  },
  watch: {
    editModal(value) {
      if (value === false) {
        this.getLocationProductList();
      }
    },
    addModal(value) {
      if (value === false) {
        this.getLocationProductList();
      }
    },
    selectedLocation(value) {
      if (value.id) {
        this.getLocationProductList();
      } else {
        this.listItem = []
      }
    }
  },
  computed: {
    page: {
      get() {
        return this.vg_page
      },
      set(value) {
        this.setProductListPage(value)
      }
    },
    pageCount: {
      get() {
        return this.vg_productListPageCount
      },
      set(value) {
        this.setProductListPageCount(value)
      }
    },
    itemsPerPage: {
      get() {
        return this.vg_productListPerPage
      },
      set(value) {
        this.setProductListPerPage(value)
      }
    },
    search: {
      get() {
        return this.vg_productListSearch
      },
      set(value) {
        this.setProductListSearch(value)
      }
    },
    ...mapGetters({
      activeItem: 'locationproduct/activeItem',
      sectionType: 'locationproduct/sectionType',
      rightBarStatus: 'navigation/rightNavStatus',
      // popup watch
      vg_page: 'locationproduct/productListPage',
      vg_productListPageCount: 'locationproduct/productListPageCount',
      vg_productListPerPage: 'locationproduct/productListPerPage',
      vg_productListSearch: 'locationproduct/productListSearch',
      addModal: 'locationproduct/addPop',
      editModal: 'locationproduct/editPop',

      productImagesPopup: 'locationproduct/productImagesPopup',
      selectedLocation: 'location/selected'
    })
  },
  async mounted() {
    this.loaded = false

    await this.getBrandList();
    await this.getLocationProductList();
    await this.getLocationCategoryList();

    this.loaded = true
  },

  methods: {
    downloadPop(type) {
      this.setProductSelectionType(type)
      this.setProductSelectionPopup(true)
    },
    customFilter(value, search, item) {
      if (search.toLocaleLowerCase() === 'no brand') {
        return item.brand_id === null
      } else {
        return defaultFilter(value, search, item)
      }
    },
    async getBrandList() {
      try {
        // brand list
        const brandData = await BrandAPI.brandList()
        this.brandList = _.sortBy(brandData.data.payload, 'name')
      } catch (err) {
        this.brandList = []
      }
    },
    async getLocationProductList() {
      try {
        this.spinner(true)
        if (this.selectedLocation.id !== undefined) {
          const locationProduct = await LocationProductAPI.fetch(this.selectedLocation.id)
          this.listItem = locationProduct.data.payload
        } else {
          this.listItem = []
        }
        this.spinner(false)
      } catch (err) {
        this.spinner(false)
        this.listItem = []
      }
    },
    async getLocationCategoryList() {
      try {
        if (this.selectedLocation.id !== undefined) {
          const locationCategoryData = await LocationCategoryAPI.fetch(this.selectedLocation.id)
          this.locationCategoryList = locationCategoryData.data.payload
        } else {
          this.locationCategoryList = []
        }
      } catch (err) {
        this.locationCategoryList = []
      }
    },
    /**
    * Get master product category name from id
    */
    getLocationProductCategoryNameFromId(id) {
      for (const category of this.locationCategoryList) {
        if (category.id === id) {
          return category.name
        } else if (Array.isArray(category.subCategory)) {
          for (const subCategory of category.subCategory) {
            if (subCategory.id === id) {
              return subCategory.name
            }
          }
        }
      }
      return '--'
    },

    /**
     * Function accept object which has an id, return confirm then delete the category
     */
    deleteItem(obj) {
      document.activeElement.blur()
      const self = this
      this.$swal({
        title: 'Are you sure?',
        type: 'warning',
        html: `You are about to delete ${obj.name}.`,
        showCloseButton: false,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        buttonsStyling: false,
        customClass: {
          container: 'custom-swal'
        }
      }).then(async function (result) {
        if (result.value) {
          self.spinner(true)
          let res = await LocationProductAPI.delete(obj.id)
          self.spinner(false)
          if (res.status === 200) {
            self.setSectionType('list')
            self.setActiveItem({})
            self.$swal(
              'Deleted!',
              `${obj.name} successfully deleted.`,
              'success'
            )

            await self.getLocationProductList();
          } else {
            self.$swal(
              'Failed!',
              'Please try again later.',
              'error'
            )
          }
        }
      })
    },

    /**
     * Get brand name from brand id
     */
    getBrandName(brandId) {
      let mybrand = this.brandList.filter(item => item.id === brandId)
      if (mybrand.length > 0) {
        return mybrand[0].name
      }
      return ''
    },

    /**
     * Open Detail section
     */
    viewDetails(productObj) {
      this.setActiveItem(productObj)
      this.setSectionType('detail')
      this.editItem(productObj)
    },

    /**
     * Edit popup setup
     */
    editItem(obj) {
      this.setEditPop(true)
      this.setEditObj(obj)
    },

    assignCategory(obj) {
      this.setAssignCatPop(true)
      this.setEditObj(obj)
    },

    productCard(obj) {
      this.setProductCardDialogValue(true)
      this.setProductObj(obj)
    },

    ...mapActions({
      setProductListPage: 'locationproduct/setProductListPage',
      setProductListPageCount: 'locationproduct/setProductListPageCount',
      setProductListPerPage: 'locationproduct/setProductListPerPage',
      setProductListSearch: 'locationproduct/setProductListSearch',
      setEditPop: 'locationproduct/setEditPop',
      setEditObj: 'locationproduct/setEditObj',
      setAssignCatPop: 'locationproduct/setAssignCatPop',
      setProductCardDialogValue: 'locationproduct/setProductCardDialogValue',
      setProductObj: 'locationproduct/setProductObj',
      setSectionType: 'locationproduct/setSectionType',
      setActiveItem: 'locationproduct/setActiveItem',
      setProductSelectionPopup: 'locationproduct/setProductSelectionPopup',
      setProductSelectionType: 'locationproduct/setProductSelectionType'
    })
  }
}
</script>
<style scoped>

</style>
